import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import TopSection from "../../LT/TopSection";
import ForecastHistoryTab from "./ForecastHistoryTab";
import MyDownloadsTab from "./MyDownloadsTab";

const ForecastHistoryPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [downloadsRefresh, setDownloadsRefresh] = useState(0);

  const handleDownloadRequested = () => {
    setActiveTab(1);
    setDownloadsRefresh((prev) => prev + 1);
  };

  return (
    <Box sx={{ px: 2, pt: 0, pb: 4 }}>
      <TopSection
        labelList={[
          { title: "Home", path: "/forecastCollabPage" },
          { title: "Forecast History" },
        ]}
        tabTitle="Forecast History"
        hideTitle
      />

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{
            "& .MuiTab-root": { textTransform: "none", fontWeight: 500, fontSize: 14 },
            "& .Mui-selected": { color: "#000 !important" },
            "& .MuiTabs-indicator": { backgroundColor: "#000" },
          }}
        >
          <Tab label="Forecast History" />
          <Tab label="My Downloads" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <ForecastHistoryTab onDownloadRequested={handleDownloadRequested} />
      )}
      {activeTab === 1 && (
        <MyDownloadsTab refreshTrigger={downloadsRefresh} />
      )}
    </Box>
  );
};

export default ForecastHistoryPage;